import React from "react";
import { AlertTriangle } from "lucide-react";

export default function ConfirmDialog({ open, title, description, confirmLabel = "Confirm", onCancel, onConfirm }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onCancel} data-testid="confirm-dialog">
      <div className="w-full max-w-md iz-card p-8" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-full bg-red-500/10 border border-red-500/20 flex items-center justify-center flex-shrink-0">
            <AlertTriangle className="w-5 h-5 text-red-400" strokeWidth={1.5}/>
          </div>
          <div className="flex-1">
            <h3 className="font-display text-xl text-white mb-2">{title}</h3>
            <p className="text-sm text-gray-400 leading-relaxed">{description}</p>
          </div>
        </div>
        <div className="flex items-center justify-end gap-3 mt-6 pt-4 border-t border-[#1a1a1a]">
          <button onClick={onCancel} className="iz-btn-secondary" data-testid="confirm-cancel">Cancel</button>
          <button onClick={onConfirm} className="iz-btn-danger px-4 py-2" data-testid="confirm-ok">{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
